import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useAdjustFinalCostMutation } from '../../../../slices/ordersApiSlice';

/** 驳回后的成本修正：改金额和原因后再提交，旧驳回单退出待办并留在履历里 */
const FinalCostReapplyModal = ({ show, onHide, approval, onSubmitted }) => {
	const detail = approval?.detail || {};
	const [adjustedCost, setAdjustedCost] = useState('');
	const [reason, setReason] = useState('');
	const [adjustFinalCost, { isLoading }] = useAdjustFinalCostMutation();

	useEffect(() => {
		if (!show) return;
		setAdjustedCost(detail.adjustedCost != null && detail.adjustedCost !== '' ? String(detail.adjustedCost) : '');
		setReason(detail.reason || '');
	}, [detail.adjustedCost, detail.reason, show]);

	const handleSubmit = async () => {
		const parsedAdjustedCost = Number(adjustedCost);
		if (!Number.isFinite(parsedAdjustedCost) || parsedAdjustedCost < 0) {
			toast.error('修正后的成本必须大于等于 0');
			return;
		}
		if (!reason.trim()) {
			toast.error('修正原因不能为空');
			return;
		}
		const orderId = detail.orderOID;
		if (!orderId || !approval?._id) {
			toast.error('缺少订单或原申请，无法重提');
			return;
		}
		try {
			await adjustFinalCost({
				orderId,
				adjustedCost: parsedAdjustedCost,
				reason: reason.trim(),
				resubmittedFrom: approval._id,
			}).unwrap();
			toast.success('修正申请已重新提交');
			onSubmitted?.();
			onHide();
		} catch (error) {
			toast.error(error?.data?.message || error?.error || '重新提交失败，请稍后重试');
		}
	};

	return (
		<Modal show={show} onHide={isLoading ? undefined : onHide} centered backdrop={isLoading ? 'static' : true} keyboard={!isLoading} className='modal-nested-stack' backdropClassName='modal-backdrop-nested'>
			<Modal.Header closeButton={!isLoading}>
				<Modal.Title className='fs-6'>再次申请最终成本修正{detail.orderId ? ` · ${detail.orderId}` : ''}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form.Group className='mb-3' controlId='reapplyAdjustedCost'>
					<Form.Label className='small fw-semibold'>修正后成本</Form.Label>
					<Form.Control type='number' min='0' step='0.01' value={adjustedCost} onChange={(e) => setAdjustedCost(e.target.value)} placeholder='请输入修正后成本' />
				</Form.Group>
				<Form.Group controlId='reapplyReason'>
					<Form.Label className='small fw-semibold'>修正原因</Form.Label>
					<Form.Control as='textarea' rows={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder='请输入修正原因' />
				</Form.Group>
			</Modal.Body>
			<Modal.Footer>
				<Button variant='outline-secondary' size='sm' disabled={isLoading} onClick={onHide}>
					取消
				</Button>
				<Button variant='primary' size='sm' disabled={isLoading} onClick={handleSubmit}>
					{isLoading ? '提交中...' : '提交申请'}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

FinalCostReapplyModal.propTypes = {
	show: PropTypes.bool,
	onHide: PropTypes.func.isRequired,
	approval: PropTypes.object,
	onSubmitted: PropTypes.func,
};

export default FinalCostReapplyModal;
